import { communityAxiosInstance, overrideCommunityHeader } from './index';

/**
 * Fetch website settings from the community API
 * @returns {Promise} API response with website settings
 */
export const fetchWebsiteSettingsRequest = () => {
  overrideCommunityHeader();
  return communityAxiosInstance.get('/api/website-settings');
};
